let undos = [];
let redos = [];

export function pushInHistory(tagsState) {
  _getStateHistory().push(tagsState);
}

export function _getStateHistory() {
  return undos;
}

export function clearStateHistory() {
  undos = [];
  redos = [];
}

export function undo() {
  // console.log("UNDOS: ", undos);
  // console.log("REDOS: ", redos);

  if (undos.length > 1) {
    redos.push(undos.pop());
    let currentState = undos[undos.length - 1];
    return currentState;
  } else {
    return undefined;
  }
}

export function redo() {
  // console.log("UNDOS: ", undos);
  // console.log("REDOS: ", redos);

  if (redos.length > 0) {
    let currentState = redos.pop();
    undos.push(currentState);
    return currentState;
  } else {
    return undefined;
  }
}

export function addingNewStates() {
  redos = [];
}

export function isUndoable () {
  return true; // undos.length > 1;
}

export function isRedoable () {
  return true; // redos.length > 0;
}